import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/congratulations.gif'


const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4 position-relative" }
const _hoisted_2 = { class: "card-body p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "mb-0" }, [
        _createTextVNode(" Congratulations, "),
        _createElementVNode("span", { class: "text-primary" }, "Olivia!")
      ], -1)),
      _cache[2] || (_cache[2] = _createElementVNode("p", null, "Best agent of the month", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "mb-0 fs-20 text-primary" }, "1.5k+", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("p", null, "Ticket Solved", -1)),
      _createVNode(_component_RouterLink, {
        to: "/my-profile",
        class: "btn btn-primary fw-medium"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(" View Profile ", -1)
        ]))]),
        _: 1
      })
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("img", {
      src: _imports_0,
      class: "congratulations wh-150 position-absolute",
      alt: "congratulations"
    }, null, -1))
  ]))
}